export const repairImages = [
  { src: "/car-new-1.jpg", alt: "Freshly finished green BMW M3 completed at EDT's bodyshop" },
  { src: "/car-new-2.jpg", alt: "BMW 3 Series rear accident repair in progress with bumper removed" },
  { src: "/car-new-3.jpg", alt: "Front bumper freshly resprayed and drying on a stand" },
  { src: "/car-new-4.jpg", alt: "Vehicle masked and covered in the spray booth ready for paint" },
  { src: "/car-new-5.jpg", alt: "White Audi Q2 detailed and finished after bodywork" },
];

// Repair-in-progress photos shown on the Motor Claims Assist page
export const claimRepairImages = [
  { src: "/claim-repair-1.jpg", alt: "Vehicle masked and prepped in the spray booth for a respray" },
  { src: "/claim-repair-2.jpg", alt: "Rear quarter panel accident repair on an estate car" },
  { src: "/claim-repair-3.jpg", alt: "Car panel masked and ready for colour in the booth" },
  { src: "/claim-repair-4.jpg", alt: "Front-end bodywork repair with bumper removed in the workshop" },
];

// Genuine driving-test booking / review proof screenshots (client-supplied, de-duplicated)
export const bookingProofImages = [
  { src: "/dt-1.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-2.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-3.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-4.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-5.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-6.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-7.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-8.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-9.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-10.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-11.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-12.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-13.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-14.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-15.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-16.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-17.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-18.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-19.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-20.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-21.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-22.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-23.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-24.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-25.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-26.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-27.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-28.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-29.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-30.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-31.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-32.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-33.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-34.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-35.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-36.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
  { src: "/dt-37.jpg", alt: "Driving test booking confirmation secured for an EDT client" },
];

export const accreditations = [
  "BSI Kitemark Certified",
  "NBRA Approved",
  "ABP Approved",
  "IMI Accredited",
  "Payment Assist Approved",
  "Insurance Approved & Accredited",
];
